import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { WebEntryLayout } from './entryHelpers';
import { patientAuthFlow } from '../../auth/patientAuthFlow';

const FEATURES = [
  { label: 'Book Doctor, Lab, Pharmacy', color: T.navy, icon: 'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2' },
  { label: 'Emergency Ambulance', color: T.danger, icon: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07' },
  { label: 'AI Health Assistant', color: T.teal, icon: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z' },
  { label: 'Consent-based record sharing', color: T.success, icon: 'M12 1L2 5v8c0 7 4.3 11 10 13 5.7-2 10-6 10-13V5L12 1z' },
];

export default function PatRegSuccessScreen() {
  const navigate = useNavigate();

  return (
    <WebEntryLayout>
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '30px 24px',
        fontFamily: T.font,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {/* Success checkmark */}
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: 20,
          background: `${T.success}1F`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
        }}
      >
        <svg width={36} height={36} viewBox="0 0 24 24" fill="none" stroke={T.success} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>

      <div style={{ fontSize: 18, fontWeight: 800, color: T.text, textAlign: 'center', marginBottom: 4 }}>Registration Submitted!</div>
      <div style={{ fontSize: 11, color: T.textSec, textAlign: 'center', marginBottom: 20 }}>Your NeoHealthCard ID is pending approval</div>

      {/* Feature cards */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}>
        {FEATURES.map((f) => (
          <div
            key={f.label}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              border: `1px solid ${T.border}`,
              borderRadius: 10,
              padding: '10px 14px',
              background: T.white,
            }}
          >
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                background: `${f.color}1A`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke={f.color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <path d={f.icon} />
              </svg>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600, color: T.text }}>{f.label}</span>
          </div>
        ))}
      </div>

      <div style={{ flex: 1 }} />

      {/* View Approval Status */}
      <button
        onClick={() => {
          // Do NOT call submitRegistration() here — it would regenerate a
          // fresh local NHC ID and overwrite the real one already set by the
          // backend registration call from the consent step. This just
          // resolves the route from the state that's already correct.
          patientAuthFlow.checkApprovalAfterLogin();
          navigate(patientAuthFlow.getRequiredRoute(), { replace: true });
        }}
        style={{
          width: '100%',
          padding: '14px 0',
          background: `linear-gradient(135deg, ${T.teal}, ${T.overlap})`,
          color: T.white,
          border: 'none',
          borderRadius: 14,
          fontSize: 14,
          fontWeight: 700,
          fontFamily: T.font,
          cursor: 'pointer',
          marginTop: 24,
          boxShadow: `0 4px 14px ${T.teal}40`,
        }}
      >
        View Approval Status
      </button>
    </div>
    </WebEntryLayout>
  );
}
